import { render, staticRenderFns } from "./BoletinPree.vue?vue&type=template&id=00259172&scoped=true&"
import script from "./BoletinPree.vue?vue&type=script&lang=js&"
export * from "./BoletinPree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00259172",
  null
  
)

export default component.exports